import React from "react";
import styles from "./Sekretariat.module.css";

const sekretariat = [

    {
        name: "Maren Kirch",
        class: "Sekretariatsteam",
        email: "info[at]iks-schule.de",
        image: require("./assets/f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg"),
    }

];

const SekretariatCard = ({ sekretariat }) => (


    <div className={styles.card}>
        <img src={sekretariat.image} alt={sekretariat.name} className={styles.image} />
        <div className={styles.class}>{sekretariat.class}</div>
        <div className={styles.name}>{sekretariat.name}</div>
        <div className={styles.email}>
            <a href={`mailto:${sekretariat.email}`}>{sekretariat.email}</a>
        </div>
    </div>
);

const SekretariatList = () => {
    return (
    <div>
        <main className="wrapper wrapperContent"style={{ marginBottom: "6rem" }}>
            <div className={styles.text}>
                <h1>SEKRETARIAT</h1>
            </div>
            <div className={styles.container}>
                        {sekretariat.map((sekretariat, index) => (
                            <SekretariatCard key={index} sekretariat={sekretariat} />
                        ))}
            </div>
        </main>

         <section className="wrapper wrapperContent">
                          <div className={styles.text}>
                              <h1>Öffnungszeiten Sekretariat </h1>


                           <table className={styles.table}>
                               <tr style={{background:"#c9e3ef"}}>
                                   <th>Montag</th>
                                   <td>7:30 - 13:00 Uhr</td>
                               </tr>
                               <tr style={{background:"#c9e3ef"}}>
                                   <th>Dienstag</th>
                                   <td>7:30 - 13:00 Uhr</td>
                               </tr>
                               <tr style={{background:"#c9e3ef"}}>
                                   <th>Mittwoch</th>
                                   <td>7:30 - 13:00 Uhr</td>
                               </tr>
                               <tr style={{background:"#c9e3ef"}}>
                                   <th>Donnerstag</th>
                                   <td>7:30 - 13:00 Uhr</td>
                               </tr>
                               <tr style={{background:"#c9e3ef"}}>
                                   <th>Freitag</th>
                                   <td>7:30 - 13:00 Uhr</td>
                               </tr>
                           </table>
                           </div>
                       </section>
    </div>


    );
};

export default SekretariatList;
